import React from "react";
import "./textField.scss";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { TextField, makeStyles } from "@material-ui/core";

const InputTextField = ({
  label,
  small = null,
  placeholder,
  variant,
  onChange,
  type,
  disabled = false,
  value,
  margin = false,
  fullWidth = false,
  multiline,
  rows,
  error,
  required = false,
  minValue = null,
  maxValue = null,
  ...rest
}) => {
  const enforceMinMax = (minValue !== null && maxValue !== null);
  const checkInputValue = ((e) => {
    if (enforceMinMax) {
      const newValue = parseInt(e.target.value);
      if (newValue <= minValue) {
        value = minValue.toString();
      }
      if (newValue >= maxValue) {
        value = maxValue.toString();
      }
    }
    onChange({target: {value: value}})
  });

  const useStyles = makeStyles((theme) => ({
    underline: {
      "&::before": {
        borderBottom: "1px solid #90caf9 !important",
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "2px solid #90caf9 !important",
      },
      "&::after": {
        borderBottom: "2px solid #90caf9 !important",
      },
    },
    input: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 1000px black inset !important",
        backgroundColor: "red !important",
      },
    },
    customTextField: {
      // width: width,
      "& .MuiInputBase-root": {
        borderRadius: "6px",
        padding: "12px 16px",
        "& input": {
          color: "#181818",
          fontSize: "14px",
          fontWeight: "500",
          fontFamily: "Gotham HTF",
          fontStyle: "normal",
        },
        "& input::placeholder": {
          color: "#C6C6C6",
          opacity: 1,
        },
      },
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#DDD",
        },
        "&:hover fieldset": {
          borderColor: "#DDD",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#000",
        },
      },
      "& .MuiOutlinedInput-input": {
        padding: "unset !important",
      },
    },
  }));
  const classes = useStyles();
  return (
    <div
      className={`textField ${margin ? "margin" : ""} ${error ? "error" : ""}`}
    >
      <FormControl className={`${fullWidth ? "w-100" : ""}`}>
        <FormLabel htmlFor="email" className="formLabel">
          {label}
          {required ? <span>*</span> : ""}
        </FormLabel>
        {small && (<small>{small}</small>)}
        <TextField
          fullWidth
          variant={variant}
          placeholder={placeholder}
          className={classes.customTextField}
          type={type}
          onChange={onChange}
          disabled={disabled}
          value={value ?? ""}
          multiline={multiline}
          minRows={rows}
          onBlur={checkInputValue}
        />
      </FormControl>
    </div>
  );
};

export default InputTextField;
